"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = exports.TitleBar = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.TitleBar = (0, flora_react_1.styled)('div', {
    alignItems: 'center',
    display: 'flex',
    padding: '$4 0',
    width: '100%',
});
exports.IconButton = (0, flora_react_1.styled)(flora_react_1.Box, {
    background: 'transparent',
    border: 'none',
    color: '$backgroundAltPrimary',
    cursor: 'pointer',
    display: 'flex',
    marginRight: '$5',
    padding: 0,
});
